<template lang="pug">
  .b-invitations-tile
    ._title Пригласить нового пользователя
    InvitationList(:items="itemsLocal" @delete="remove")
    ._footer
      BaseInput._input(v-model="email.value" :error="email.error" :label="email.label")
      Btn._btn-add(@click="add" medium) Добавить
      Btn._btn-send(@click="send" :disabled="!sendIsAvailable" medium) Отправить
      PopupAlert(ref="popup") Уведомления отправлены
</template>

<script>
import form from '@/utils/form';

import invitationApi from '@/api/invitation';

import FormBlock from '@/components/FormBlock.vue';
import InvitationList from '@/components/invitation/InvitationList.vue';
import BaseInput from '@/components/BaseInput.vue';
import PopupAlert from '@/components/base/PopupAlert.vue';

export default {
  name: 'InvitationsTile',
  components: { PopupAlert, FormBlock, InvitationList, BaseInput }, // eslint-disable-line
  props: {
    items: Array,
    project: Object,
  },
  data() {
    return {
      itemsLocal: [],
      email: form.createFieldObject('email', 'E-mail', '', { required: 'Укажите почту', email: 'Почта некорректна' }),
    };
  },
  computed: {
    sendIsAvailable() {
      return this.itemsLocal.length > 0 && !!this.itemsLocal.find((i) => i.isSent === false);
    },
  },
  watch: {
    items: {
      immediate: true,
      handler(val) { this.itemsLocal = [...val]; },
    },
  },
  methods: {
    add() {
      form.validateField(this, 'email');

      if (this.email.value.toLowerCase() === this.$store.state.auth.user?.email?.toLowerCase()) {
        this.email.error = 'Это Ваш e-mail';
      }

      if (this.email.error) return;

      invitationApi.create({ email: this.email.value, project: this.project?.['@id'] }, true)
        .then((r) => { this.itemsLocal.push(r); });

      this.email.value = '';
    },
    remove(invitation) {
      invitationApi.delete(invitation.id, true).then(() => {
        this.itemsLocal = this.itemsLocal.filter((i) => i.id !== invitation.id);
      });
    },
    send() {
      invitationApi.send(this.project?.id, true)
        .then(() => {
          this.$emit('reload');
          this.$refs.popup.open();
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .invitations-tile {
    display: flex;
    flex-direction: column;
    gap: 30px;

    &__title {
      font-size: 18px;
      line-height: 24px;
      color: var(--color-super-dark);
    }

    &__footer {
      display: flex;
      gap: 25px;
      align-items: center;
    }

    &__btn-send {
      margin-left: auto;
    }

    &__input {
      width: 400px;
    }

    @media (max-width: 1050px) {
      &__input {
        width: auto;
        flex-grow: 1;
      }
    }

    @media (max-width: 650px) {
      &__footer {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
      }

      &__btn-send {
        margin-left: initial;
      }
    }
  }
</style>
